var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.ClickMenu,{staticClass:"equipment-filter",attrs:{"value":_vm.value,"ids":_setup.deviceIds,"names":_setup.deviceNames,"title":_vm.$t('report.devices'),"type":_vm.single ? 'single' : 'multiple',"icon":"cutting","iconPack":"bys-icon"},on:{"input":function($event){return _setup.emitValue($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }